import { render, staticRenderFns } from "./authorization-role.vue?vue&type=template&id=21b0e93c"
import script from "./authorization-role.vue?vue&type=script&lang=js"
export * from "./authorization-role.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports